import React from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";

const { Header, Content, Footer } = Layout;

const LoginLayout: React.FC = () => {
  return (
    <Layout className="layout" style={{ minHeight: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#1890ff",
        }}
      >
        <div className="demo-logo" />
      </Header>
      {/* Centres whichever auth page is routed here, so login, forgot-password
          and reset-password all sit in the same spot instead of each carrying
          its own ad-hoc paddingTop / marginLeft nudge. Each page renders a
          single fixed-width element: a fragment with two roots would become two
          flex items and sit side by side. */}
      <Content
        style={{
          padding: "40px 50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Outlet />
      </Content>
      <Footer style={{ textAlign: "center" }}>
        {new Date().getFullYear()} © Smart Solutions
      </Footer>
    </Layout>
  );
};

export default LoginLayout;
